import React from 'react'
import { Link } from "react-router-dom";
import styled from 'styled-components'
import PetConnect from '../icons/Footer-Logo.svg'

const Footer = () => {
    return (
        <StyledFooter to="/">
            <CompanyInfo>
            <Logo><img src={PetConnect} alt='Pet connect logo' title="Home"/></Logo>
            <ul>
            <h2>COMPANY</h2>
            <Link to="/about" title="About">About</Link>
            <Link to="/team" title="Team">Team</Link>
            </ul>
            </CompanyInfo>
            <Line className="center"></Line>
            <p>&#169; 2021 PetConnect</p>
        </StyledFooter>
    )
}

const StyledFooter = styled(Link)`
display: flex;
flex-direction: column;
background-color: #0C3139;
min-height: 25vh;
h2{
    font-weight: normal;
    font-size: 1.4rem;
    color: #FFFFFF;
    opacity: 0.4;
}

p{
    margin: 0rem auto; 
    opacity: 0.5;
    color: white;
}
`;

const Logo = styled.div `
display: flex;
align-items: flex-start;
`;

const Line = styled.div `
border: 0.000000000000000000000000001rem solid #ffffff;
background-color: white;
text-align: center;
opacity: 0.3;
margin: 0rem 13rem;
`;


const CompanyInfo = styled(Link)`
display: flex ;
justify-content: space-between;
margin: 2rem 13.2rem 1rem 13.2rem;

a {
    display: flex;
    justify-content: flex-end;
    font-size: 1.1rem;
    color: white;
    line-height: 2.3;
}
`;

export default Footer;